<template>
  <div>
    <PageAllow controller="SubAccountAnalyses" action="subAccountOrderView" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row class="mx-2">
          <v-col>
            <v-tabs v-model="tab" background-color="transparent">
              <v-tab>
                <h4>{{ $t("subAccountQuery.Detail.sub_account_details") }}</h4>
              </v-tab>
              <v-tab>
                <h4>{{ $t("subAccountQuery.Detail.order_details") }}</h4>
              </v-tab>
            </v-tabs>
          </v-col>
          <v-spacer />
          <span class="d-flex align-center">
            <v-btn
              v-if="
                $permission.permissionAllow(
                  'SubAccountAnalyses',
                  'subAccountOrderViewExport'
                )
              "
              small
              color="print"
              dark
              class="ms-1 mr-2"
              href=""
              @click.stop="exportsOrder()"
            >
              <v-icon x-small class="pe-1">fa-file-excel</v-icon>
              {{ $t("subAccountQuery.Detail.export") }}
            </v-btn>
          </span>
        </v-row>
        <v-tabs-items
          v-model="tab"
          class="transparent-background-color pb-4 mt-1"
        >
          <v-tab-item>
            <v-card class="mx-3">
              <v-data-table
                :headers="subAccountHeaders"
                :items="sub_account_details"
                multi-sort
                class="px-4"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:top>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.shop_name")
                        }}{{ $t("Global.colon") }}
                        <span>
                          {{
                            $t("subAccountQuery.Detail.shop", [
                              sub_account_info.shop_code,
                              sub_account_info.shop_name,
                            ])
                          }}</span
                        >
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <span>
                          {{ $t("subAccountQuery.Detail.order_created_time")
                          }}{{ $t("Global.colon") }}
                        </span>
                        <span>
                          {{ sub_account_info.order_code }}
                          <span class="caption">
                            ({{
                              sub_account_info.order_created_time | formatTime
                            }})
                          </span></span
                        >
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.bill_code")
                        }}{{ $t("Global.colon") }}
                        <span> {{ sub_account_info.bill_code }}</span>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.fee")
                        }}{{ $t("Global.colon") }}
                        <span>
                          {{ $t("Global.money")}}
                          {{ sub_account_info.fee | formatMoney }}
                        </span>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.logistics_fee")
                        }}{{ $t("Global.colon") }}
                        <span>
                          {{ $t("Global.money")}}
                          {{ sub_account_info.logistics_fee | formatMoney }}
                        </span>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="settings && settings.service_charge_enable">
                        {{ $t("subAccountQuery.Detail.service_charge")
                        }}{{ $t("Global.colon") }}
                        <span>
                          {{ $t("Global.money")}}
                          {{ sub_account_info.service_charge | formatMoney }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.payment_time="{ item }">
                  {{ item.payment_time | formatTime }}
                </template>
                <template v-slot:item.sub_account_time="{ item }">
                  {{ item.sub_account_time | formatTime }}
                </template>
                <template v-slot:item.sub_account_money="{ item }">
                  {{ $t("Global.money") }}
                  {{ item.sub_account_money | formatMoney }}
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card class="mx-3">
              <v-data-table
                :headers="OrdersHeaders"
                :items="order_details"
                multi-sort
                class="px-4"
                disable-pagination
                hide-default-footer
              >
                <template v-slot:top>
                  <v-card-text>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.shop_name")}}{{ $t("Global.colon") }}
                        <span>
                          {{
                            $t("subAccountQuery.Detail.shop", [
                              sub_account_info.shop_code,
                              sub_account_info.shop_name,
                            ])
                          }}</span
                        >
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        <span>
                          {{ $t("subAccountQuery.Detail.order_created_time")}}{{ $t("Global.colon") }}
                        </span>
                        <span>
                          {{ sub_account_info.order_code }}
                          <span class="caption">
                            ({{
                              sub_account_info.order_created_time | formatTime
                            }})
                          </span>
                        </span>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.bill_code") }}{{ $t("Global.colon") }}
                        <span> {{ sub_account_info.bill_code }}</span>
                      </v-col>
                    </v-row>
                    <v-row dense>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.fee")}}{{ $t("Global.colon") }}
                        <span>
                          {{ $t("Global.money")}}
                          {{ sub_account_info.fee | formatMoney }}
                        </span>
                      </v-col>
                      <v-col cols="12" sm="6" md="4">
                        {{ $t("subAccountQuery.Detail.logistics_fee")}}{{ $t("Global.colon") }}
                        <span>
                          {{ $t("Global.money")}}
                          {{ sub_account_info.logistics_fee | formatMoney }}
                        </span>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" v-if="settings && settings.service_charge_enable">
                        {{ $t("subAccountQuery.Detail.service_charge") }}{{ $t("Global.colon") }}
                        <span>
                          {{ $t("Global.money")}}
                          {{ sub_account_info.service_charge | formatMoney }}
                        </span>
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-divider></v-divider>
                </template>
                <template v-slot:item.fix_num="{ item }">
                  {{ item.fix_num | formatTwoDot }}{{ item.unit }}
                </template>
                <template v-slot:item.price="{ item }">
                  {{ $t("Global.money") }}
                  {{ item.price | formatMoney }}
                </template>
                <template v-slot:item.total="{ item }">
                  {{ $t("Global.money") }}
                  {{ item.total | formatMoney }}
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-sheet>
    </v-slide-x-transition>
  </div>
</template>
<script>
import { mapState } from "vuex";
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import SubAccountAnalyses from "@/api/sub_account_analyses";

export default {
  components: {
    PageAllow,
    Breadcrumbs,
  },
  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.subAccountQuery"),
          disabled: false,
          href: "/sub-account-orders",
        },
        {
          text:
            this.sub_account_info && this.sub_account_info.order_code
              ? i18n.t("subAccountQuery.Detail.order_code", [
                  this.sub_account_info.order_code,
                ])
              : "",
          disabled: false,
          accent: true,
        },
      ];
    },
    subAccountHeaders() {
      return [
        {
          text: i18n.t("subAccountQuery.Detail.Fields.voucher_code"),
          align: "start",
          sortable: false,
          value: "voucher_code",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.payment_time"),
          align: "start",
          sortable: false,
          value: "payment_time",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.sub_account_money"),
          align: "start",
          sortable: false,
          value: "sub_account_money",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.sub_account_status_str"),
          align: "start",
          sortable: false,
          value: "sub_account_status_str",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.sub_account_time"),
          align: "start",
          sortable: false,
          value: "sub_account_time",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.account_name"),
          align: "start",
          sortable: false,
          value: "account_name",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.sub_account_type_str"),
          align: "start",
          sortable: false,
          value: "sub_account_type_str",
        },
      ];
    },
    OrdersHeaders() {
      return [
        {
          text: i18n.t("subAccountQuery.Detail.Fields.material_code"),
          align: "start",
          sortable: false,
          value: "material_code",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.material_name"),
          align: "start",
          sortable: false,
          value: "material_name",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.category_name"),
          align: "start",
          sortable: false,
          value: "category_name",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.fix_num"),
          align: "start",
          sortable: false,
          value: "fix_num",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.price"),
          align: "start",
          sortable: false,
          value: "price",
        },
        {
          text: i18n.t("subAccountQuery.Detail.Fields.total"),
          align: "start",
          sortable: false,
          value: "total",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["settings"]),
  },
  data: () => ({
    tab: null,
    mode: null,
    paging: {},
    sub_account_details: [],
    order_details: [],
    sub_account_info: {},
  }),
  mounted() {
    this.getOrderDetailFromAPI();
  },
  methods: {
    getOrderDetailFromAPI() {
      SubAccountAnalyses.fetchOrder(this.$route.params.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.sub_account_info = response.data.sub_account_info;
            this.sub_account_details = response.data.sub_account_details;
            this.order_details = response.data.order_details;
          }
        }.bind(this)
      );
    },
    exportsOrder() {
      SubAccountAnalyses.exportsOrder(this.sub_account_info.order_id, {
        mode: this.mode,
      });
    },
  },
  watch: {
    tab: {
      handler() {
        if (this.tab == 0) {
          this.mode = 1;
        } else if (this.tab == 1) {
          this.mode = 2;
        }
      },
    },
  },
};
</script>
